import React from 'react';

import LinkTextComponent from '../linkTextComponent/linkTextComponent';
import MultiStateButton from '../multiStateButton/multiStateButton';

import './formComponentV2.css';

const FormComponentV2 = ({
  showRightBtn = true,
  isLeftBtnDisabled = false,
  isRightBtnDisabled = true,
  showCloseBtn = false,
  showDeleteUIInLeftBtn = false,
  showLeftBtnSpinner = false,
  showRightBtnSpinner = false,
  showSecondaryUIInRightBtn = false,
  showShakeAnim = false,
  children = <></>,
  formSubTitle = null,
  formTitle = '',
  leftBtnTxt = 'Cancel',
  rightBtnTxt = 'Save',
  formSubTitleLinkTxt = 'Read more.',
  formSubTitleLinkUrl = null,
  onCloseBtnClicked = () => {},
  onLeftBtnClicked = () => {},
  onRightBtnClicked = () => {},
}) => {
  return (
    <div className="et-v2-form-component-container">
      <div className="et-v2-form-component-content-wrap">
        <div className="et-v2-form-component-top-header-wrap">
          <div className="et-v2-form-title-sub-title-wrap">
            <div className="et-v2-fc-form-title-txt">{formTitle}</div>
            {formSubTitle && (
              <div className="et-v2-fc-form-sub-title-txt">
                {formSubTitle}
                {formSubTitleLinkUrl && (
                  <LinkTextComponent
                    isSubTitleSizeTxt={false}
                    linkTxt={formSubTitleLinkTxt}
                    linkUrl={formSubTitleLinkUrl}
                  />
                )}
              </div>
            )}
          </div>
          {showCloseBtn && (
            <div className="et-v2-fc-form-btn">
              <MultiStateButton
                isPrimaryBtn
                btnTxt="Close"
                onClick={onCloseBtnClicked}
              />
            </div>
          )}
        </div>
        <div
          className={`et-v2-fc-form-children-wrap  ${
            showShakeAnim ? 'et-v2-fc-shake-form' : ''
          }`}>
          {children}
        </div>
        <div
          className={`et-v2-fc-form-cancel-save-wrap ${
            !showRightBtn ? 'et-v2-fc-form-single-btn-wrap' : ''
          }`}>
          <div className="et-v2-fc-form-btn et-v2-fc-left-btn">
            <MultiStateButton
              isDeleteBtn={showDeleteUIInLeftBtn}
              isDisabled={isLeftBtnDisabled}
              showSpinner={showLeftBtnSpinner}
              btnTxt={leftBtnTxt}
              onClick={onLeftBtnClicked}
            />
          </div>
          {showRightBtn && (
            <div className="et-v2-fc-form-btn et-v2-fc-right-btn">
              <MultiStateButton
                isPrimaryBtn={!showSecondaryUIInRightBtn}
                isDisabled={isRightBtnDisabled}
                showSpinner={showRightBtnSpinner}
                btnTxt={rightBtnTxt}
                onClick={onRightBtnClicked}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormComponentV2;
